import {
  h,
  Component,
  toChildArray,
  createContext,
  JSX,
  ComponentChildren
} from 'preact';
import { createTranslator } from '../js/translator';

type PropTypes = {
  locale?: string;
  translations?: Object;
  customTranslations?: Record<string, any>;
};

const TranslatorContext = createContext({
  translator: (str: string) => str
});

export function withTranslator<T>(ComponentToWrap: any) {
  return class Translator extends Component<
    PropTypes & { children?: ComponentChildren } & T
  > {
    render(): JSX.Element {
      return (
        <TranslatorContext.Consumer>
          {context => (
            <ComponentToWrap {...this.props} translate={context.translator} />
          )}
        </TranslatorContext.Consumer>
      );
    }
  };
}

export default class TranslatorProvider extends Component<
  PropTypes & { children: ComponentChildren }
> {
  render(): JSX.Element {
    const ctx = {
      translator: createTranslator(
        this.props.locale,
        this.props.translations,
        this.props.customTranslations
      )
    };
    return (
      <TranslatorContext.Provider value={ctx}>
        {toChildArray(this.props.children)[0]}
      </TranslatorContext.Provider>
    );
  }
}
